import { render } from "./LoginWithOTP.vue?vue&type=template&id=033d9a02"
import script from "./LoginWithOTP.vue?vue&type=script&lang=js"
export * from "./LoginWithOTP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__